module.exports = __webpack_public_path__ + "static/media/20_000007.efaf5784.jpg";